export const getCurrentUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    return {};
  }
};

export const getCurrentRole = () => {
  return getCurrentUser().role;
};

export const hasRole = (...roles) => {
  if (!roles.length) return true;

  return roles.includes(getCurrentRole());
};

export const isSuperAdmin = () => hasRole("superadmin");